import React, { RefObject, useMemo } from 'react';

import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';

import { DropdownItem } from '@atlaskit/dropdown-menu-12';

import { SourceViewLink } from 'src/components/diff-set/components/source-view-link';
import { publishPullRequestUiEvent } from 'src/redux/pull-request/actions';
import urls from 'src/urls/source';

import messages from '../../diff.i18n';

type Props = {
  filepath: string;
  isDeleted?: boolean;
  sourceHash: string;
  destinationHash?: string;
  sourceRepoFullSlug: string;
  destinationRepoFullSlug?: string;
};

/* eslint @typescript-eslint/ban-types: "warn" */
export const ViewSourceItem: React.FC<Props> = ({
  filepath,
  isDeleted,
  sourceHash,
  destinationHash,
  sourceRepoFullSlug,
  destinationRepoFullSlug,
}) => {
  const dispatch = useDispatch();

  const repositoryFullSlug = isDeleted
    ? destinationRepoFullSlug
    : sourceRepoFullSlug;
  const hash = isDeleted ? destinationHash : sourceHash;

  const viewHref = urls.ui.source(repositoryFullSlug!, {
    refOrHash: hash,
    path: filepath,
  });

  const OpenLink = useMemo(
    () =>
      React.forwardRef(
        (
          { className }: { className: string },
          ref: RefObject<HTMLAnchorElement>
        ) => (
          <SourceViewLink
            className={className}
            target="_blank"
            ref={ref}
            role="menuitem"
            viewHref={viewHref}
            onClick={() =>
              dispatch(
                publishPullRequestUiEvent({
                  action: 'clicked',
                  actionSubject: 'button',
                  actionSubjectId: 'pullRequestOpenInSourceButton',
                })
              )
            }
          >
            <FormattedMessage {...messages.viewFile} />
          </SourceViewLink>
        )
      ),
    [dispatch, viewHref]
  );

  return (
    <DropdownItem key="file-actions-menu-view" component={OpenLink}>
      {' '}
    </DropdownItem>
  );
};
